import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  getWarningsFailure,
  getWarningsSuccess,
  saveWarningSuccess,
  saveWarningFailure,
  updateWarningSuccess,
  updateWarningFailure,
} from "./actions";
import { GET_WARNINGS, SAVE_WARNING, UPDATE_WARNING } from "./constants";
import { capitalizeFirstLetter } from "../../utils/helpers";

export function* getWarningsSaga({
  payload = { cancelToken: null },
  onSuccess,
}) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/care-plan-warning-alert?${query}`,
    );
    yield put(getWarningsSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(getWarningsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching network!"));
  }
}

export function* saveWarningSaga({
  payload = { cancelToken: null },
  onSuccess,
}) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/care-plan-warning-alert/add`,
      payload,
    );
    yield put(saveWarningSuccess(data));
    yield put(
      successAlert(
        `${capitalizeFirstLetter(payload.type)} saved successfully!`,
      ),
    );
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(saveWarningFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while saving warning!"));
  }
}

export function* updateWarningSaga({
  payload = { cancelToken: null },
  onUpdate,
}) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { type, id, formData } = payload;
  try {
    const { data } = yield call(
      api(token).post,
      `/api/care-plan-warning-alert/${type}/resident/${id}`,
      formData,
    );
    yield put(updateWarningSuccess(data));
    yield put(successAlert("Warning updated successfully!"));
    typeof onUpdate === "function" && onUpdate();
  } catch (e) {
    yield put(updateWarningFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while updating warning!"));
  }
}

export function* getWarningsFlow() {
  yield takeEvery(GET_WARNINGS, getWarningsSaga);
}
export function* saveWarningFlow() {
  yield takeEvery(SAVE_WARNING, saveWarningSaga);
}
export function* updateWarningFlow() {
  yield takeEvery(UPDATE_WARNING, updateWarningSaga);
}

export default function* ResidentWarningsSaga() {
  yield all([getWarningsFlow(), saveWarningFlow(), updateWarningFlow()]);
}
